module.exports = __webpack_public_path__ + "media/images/twitter-icon-rounded-square-06ff10e19517c79d278d1d705524d71c.svg";